(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-inventory"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const modal = document.getElementById('size-chart-modal');
    const openBtn = document.getElementById('open-size-chart');
    const closeBtn = modal.querySelector('.close-size-chart');
    const inventoryText = document.querySelector('[id^="Inventory-"]');

    // Modal logic
    openBtn.addEventListener('click', () => modal.classList.add('active'));
    closeBtn.addEventListener('click', () => modal.classList.remove('active'));
    modal.addEventListener('click', (e) => { if (e.target === modal) modal.classList.remove('active'); });

    // Variant change handler (fix bubble duplication)
    document.addEventListener('shopify:variant:change', function(event) {
      const variant = event.detail.variant;
      if (!variant || !inventoryText) return;

      const threshold = parseInt(inventoryText.dataset.threshold);
      const wrapper = inventoryText.closest('.inventory-text-wrapper');
      const existingBubble = wrapper.querySelector('.scarcity-bubble');

      if (existingBubble) existingBubble.remove();

      let message = '';
      if (variant.inventory_management === 'shopify') {
        const qty = variant.inventory_quantity || 0;
        const policy = variant.inventory_policy;

        if (qty > 0) {
          if (qty <= threshold) {
            message = ` Hurry!Place your Order Now! Only ${qty} left in stock.`;
            const bubble = document.createElement('span');
            bubble.className = 'scarcity-bubble';
            wrapper.prepend(bubble);
          } else {
            message = 'In stock — ready to ship!';
          }
        } else {
          message = policy === 'continue' ? 'In stock — ready to ship!' : 'Out of stock';
        }
      } else {
        message = 'In stock — ready to ship!';
      }

      inventoryText.textContent = message;
    });
  });
  } catch(e) { console.error(e); }
})();

})();
